var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("发货单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("table", { staticClass: "custom-tbl" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("tbody", { staticClass: "body" }, [
          _c("tr", { staticClass: "row align-left" }, [
            _c(
              "td",
              {
                staticClass: "align-left ellipsis",
                attrs: { title: _vm.goodsShipVoucher.sellerName }
              },
              [_vm._v(_vm._s(_vm.goodsShipVoucher.sellerName))]
            ),
            _vm._v(" "),
            _c("td", { staticStyle: { width: "200px" } }, [
              _vm._v(_vm._s(_vm.goodsShipVoucher.senderContactName))
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { width: "200px" } }, [
              _vm._v(_vm._s(_vm.goodsShipVoucher.senderContactTel))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("table", { staticClass: "custom-tbl" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("tbody", { staticClass: "body" }, [
          _c("tr", { staticClass: "row align-left" }, [
            _c(
              "td",
              {
                staticClass: "ellipsis",
                staticStyle: { width: "200px", "text-align": "left" },
                attrs: { title: _vm.goodsShipVoucher.buyerShopName }
              },
              [_c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.buyerShopName))])]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "ellipsis",
                staticStyle: { width: "200px", "text-align": "left" },
                attrs: { title: _vm.goodsShipVoucher.buyerBizUnitName }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.goodsShipVoucher.buyerBizUnitName))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "ellipsis",
                attrs: { title: _vm.goodsShipVoucher.buyerRecvAddr }
              },
              [_vm._v(_vm._s(_vm.goodsShipVoucher.buyerRecvAddr))]
            ),
            _vm._v(" "),
            _c("td", { staticStyle: { width: "200px" } }, [
              _vm._v(_vm._s(_vm.goodsShipVoucher.buyerRecvContractName))
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { width: "200px" } }, [
              _vm._v(_vm._s(_vm.goodsShipVoucher.buyerRecvContactTel))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-form",
            { ref: "goods", attrs: { model: _vm.goodsShipVoucher } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsShipVoucher.itemList,
                    border: "",
                    maxHeight: "400",
                    "summary-method": _vm.getDoodsShipVoucher,
                    "show-summary": ""
                  }
                },
                [
                  _vm.showAssetInfo
                    ? _c(
                        "el-table-column",
                        { attrs: { align: "center", label: "资产信息" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "130",
                              prop: "devcName",
                              label: "名称",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "100",
                              prop: "devcCatName",
                              label: "分类",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "100",
                              prop: "devcBrandName",
                              label: "品牌",
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAssetInfo
                    ? _c(
                        "el-table-column",
                        { attrs: { align: "center", label: "商品信息" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "130",
                              prop: "title",
                              label: "名称",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "100",
                              prop: "catName",
                              label: "分类",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "100",
                              prop: "brandName",
                              label: "品牌",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "160",
                              label: "需要供应商提供唯一标识码"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.vendorUknoFlag
                                      ? _c("span", [_vm._v("是")])
                                      : _c("span", [_vm._v("否")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "60",
                              prop: "setupFlag",
                              label: "需要安装"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.setupFlag
                                      ? _c("span", [_vm._v("是")])
                                      : _c("span", [_vm._v("否")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "80",
                              prop: "asmblFlag",
                              label: "含组装商品"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.asmblFlag
                                      ? _c("span", [_vm._v("是")])
                                      : _c("span", [_vm._v("否")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "60",
                              prop: "asmblFlag",
                              label: "组装件"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.asmblAccFlag
                                      ? _c("span", [_vm._v("是")])
                                      : _c("span", [_vm._v("否")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              width: "100",
                              prop: "asmblFlag",
                              label: "安装时完成组装"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.asmblWhileSetup
                                      ? _c("span", [_vm._v("是")])
                                      : _c("span", [_vm._v("否")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              width: "100",
                              prop: "price",
                              label: "含税价(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.price != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(rows.row.price.toFixed(2))
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              width: "100",
                              prop: "taxRate",
                              label: "税率(%)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.taxRate != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(rows.row.taxRate.toFixed(2))
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              width: "100",
                              prop: "ntxPrice",
                              label: "未税价(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.ntxPrice != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(rows.row.ntxPrice.toFixed(2))
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              width: "150",
                              prop: "amount",
                              label: "费用小计(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.amount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(rows.row.amount.toFixed(2))
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              width: "150",
                              prop: "ntxAmount",
                              label: "未税小计(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.ntxAmount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              rows.row.ntxAmount.toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              width: "100",
                              prop: "quantity",
                              label: "发货数量"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          (rows.row.quantity || 0) -
                                            (rows.row.offsetQuantity || 0)
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              width: "100",
                              prop: "recvQuantity",
                              label: "收货数量"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(rows.row.recvQuantity || 0))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "desc",
                              label: "说明",
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "left",
                          prop: "title",
                          label: "名称",
                          width: "150",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "120",
                          prop: "catName",
                          label: "分类",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "100",
                          prop: "brandName",
                          label: "品牌",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "160",
                          label: "需要供应商提供唯一标识码"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.vendorUknoFlag
                                  ? _c("span", [_vm._v("是")])
                                  : _c("span", [_vm._v("否")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "60",
                          prop: "setupFlag",
                          label: "需要安装"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.setupFlag
                                  ? _c("span", [_vm._v("是")])
                                  : _c("span", [_vm._v("否")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "80",
                          prop: "asmblFlag",
                          label: "含组装商品"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.asmblFlag
                                  ? _c("span", [_vm._v("是")])
                                  : _c("span", [_vm._v("否")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "60",
                          prop: "asmblFlag",
                          label: "组装件"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.asmblAccFlag
                                  ? _c("span", [_vm._v("是")])
                                  : _c("span", [_vm._v("否")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "100",
                          prop: "asmblFlag",
                          label: "安装时完成组装"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.asmblWhileSetup
                                  ? _c("span", [_vm._v("是")])
                                  : _c("span", [_vm._v("否")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "100",
                          prop: "price",
                          label: "含税价(元)"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.price != null
                                  ? _c("span", [
                                      _vm._v(_vm._s(rows.row.price.toFixed(2)))
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "100",
                          prop: "taxRate",
                          label: "税率(%)"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.taxRate != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(rows.row.taxRate.toFixed(2))
                                      )
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "100",
                          prop: "ntxPrice",
                          label: "未税价(元)"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.ntxPrice != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(rows.row.ntxPrice.toFixed(2))
                                      )
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "150",
                          prop: "amount",
                          label: "费用小计(元)"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.amount != null
                                  ? _c("span", [
                                      _vm._v(_vm._s(rows.row.amount.toFixed(2)))
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "150",
                          prop: "ntxAmount",
                          label: "未税小计(元)"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.ntxAmount != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(rows.row.ntxAmount.toFixed(2))
                                      )
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "100",
                          prop: "quantity",
                          label: "发货数量"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      (rows.row.quantity || 0) -
                                        (rows.row.offsetQuantity || 0)
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          width: "100",
                          prop: "recvQuantity",
                          label: "收货数量"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(rows.row.recvQuantity || 0))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "left",
                          prop: "desc",
                          label: "说明",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.ukQuantity > 0
                              ? _c(
                                  "i",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.showGoodsUkno(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("查看商品标识码")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.expectArriveDate || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.logisComName || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.logisComCode || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.driverName || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.driverMobile || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.vehicleLsnNo || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(12),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.logisExpNo || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(13),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.logisFee || "无"))])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.goodsShipVoucher.exceptional
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("异常描述")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.goodsShipVoucher.exceptional
        ? _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.exceptionDesc))])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.goodsShipVoucher.shipVoucherFileList != null &&
      _vm.goodsShipVoucher.shipVoucherFileList.length > 0
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("发货附件")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.goodsShipVoucher.shipVoucherFileList != null &&
      _vm.goodsShipVoucher.shipVoucherFileList.length > 0
        ? _c(
            "div",
            { staticClass: "file-view-list" },
            [
              _vm._m(14),
              _vm._v(" "),
              _vm._l(_vm.goodsShipVoucher.shipVoucherFileList, function(
                fileInfo,
                index
              ) {
                return [
                  _c("swb-file-item-li", {
                    attrs: {
                      trackKey: index,
                      fileName: fileInfo.name,
                      fileBrowseUrl: fileInfo.fileBrowseUrl,
                      fileDownloadUrl: fileInfo.fileBrowseUrl,
                      fileUuid: fileInfo.fileUuid,
                      deletable: false
                    }
                  })
                ]
              })
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("卖家信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row align-left" }, [
        _c("th", { staticClass: "align-left" }, [_vm._v("卖家名称")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [_vm._v("发货人")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [
          _vm._v("发货人联系方式")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("零售机构信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row align-left" }, [
        _c("th", { staticStyle: { width: "200px", "text-align": "left" } }, [
          _vm._v("业务单元")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px", "text-align": "left" } }, [
          _vm._v("所属部门")
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("收货地址")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [_vm._v("联系人")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [_vm._v("联系方式")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("物流信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计到货时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司代码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("司机姓名")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("司机电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("车辆牌号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("物流单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("物流费用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a47cfc0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a47cfc0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsShipVoucherInfo.vue
// module id = 2956
// module chunks = 0